<template>
  <div v-if="stockpiling.site">
    <Field label="Tarp Specifics">
      <div v-if="usableTarpWidths.length" class="flex flex-column mt-3">
        <div class="row flex surface-overlay">
          <div class="cell font-bold w-6">Allowed Tarp Widths</div>
          <div class="cell font-bold text-center">Welded</div>
          <div class="cell font-bold text-center">Sewn</div>
        </div>
        <div
          v-for="tarp_width in usableTarpWidths"
          :key="tarp_width" 
          class="row flex surface-overlay"
        >
          <div class="cell w-6">{{ tarp_width }}m</div>
          <div class="cell text-center text-400">
            <MaterialIcon :icon="weldIcon[0]" :class="weldIcon[1]" />
          </div>
          <div class="cell text-center text-400">
            <MaterialIcon :icon="sewnIcon[0]" :class="sewnIcon[1]" />
          </div>
        </div>
      </div>
      <div v-else class="mt-3">
        <div class="text-center text-400">No tarp widths specified in stockpiling requirements.</div>
      </div>
    </Field>
  </div>
</template>

<script>
import { useRecordStockpilingStore } from '@/stores/RecordStockpiling';
import { useStockpilingRequirementsStore } from '@/stores/StockpilingRequirements';

import Field from '@/components/forms/Field.vue';
import MaterialIcon from '@/components/icons/MaterialIcon.vue';

export default {
  name: 'TarpSpecifics',
  components: {
    Field,
    MaterialIcon,
  },
  created() {
    this.recordStore = useRecordStockpilingStore();
    this.store = useStockpilingRequirementsStore();
  },
  computed: {
    stockpiling() {
      return this.recordStore.stockpiling;
    },
    stockpilingRequirements() {
      return this.store.getStockpilingRequirementsBySiteID(this.stockpiling.site);
    },
    usableTarpWidths() {
      return this.stockpilingRequirements?.usable_tarp_widths || [];
    },
    weldIcon() {
      return (this.stockpilingRequirements.tarp_join_types.includes('weld')) 
        ? ['check', 'enabled'] 
        : ['close', 'disabled'];
    },
    sewnIcon() {
      return (this.stockpilingRequirements.tarp_join_types.includes('sew')) 
        ? ['check', 'enabled'] 
        : ['close', 'disabled'];
    },
  }
}

</script>

<style scoped>
.cell {
  padding: 10px 10px 6px;
  border: 1px solid black;
  width: 25%;
}
.cell:not(:first-child) {
  margin-left: -1px;
}
.row:not(:first-child) {
  margin-top: -1px;
}

.border-right-only {
  border: none;
  border-right: 1px solid black;

}
.border-left-only {
  border: none;
  border-left: 1px solid black;
}

.enabled {
  color: green;
}
.disabled {
  color: red;
}
  
</style>